/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
// import * as firebase from 'firebase'
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/storage';
var database = firebase.database()
var pollRef = database.ref('/poll')
var Success = "Success";
var Error = "Error";
var storageRef = firebase.storage()
var dateFormat = require('dateformat');

export default {
  saveValue({ commit }, item) {
    return new Promise(async (resolve, reject) => {
      var result = '';
      var characters = '0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < 7; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      const obj = {
        detail: item.detail,
        topic: item.name,
        uid: item.uid,
        login: item.type,
        pin: await result,
        status: true,
        statusPublic: false,
      }
      pollRef.push(obj).then((res) => {
        pollRef.child(res.key).update({ 'key': res.key }).then(async () => {
          const obj = {
            detail: item.detail,
            topic: item.name,
            uid: item.uid,
            type: item.type,
            pin: await result,
            status: true,
            key: res.key,
            statusPublic: false
          }
          commit('SAVE_POLL', obj)
        })
        resolve(Success);
      }).catch((err) => {
        reject(Error);
      });
    });
  },
  GetData({ commit }, uid) {
    return new Promise(async (resolve, reject) => {
      var _data = [];
      var key = "";

      await firebase.database().ref("poll").orderByKey().once("value")
        .then(async function (snapshot) {

          if (snapshot.val() == null) {
            resolve(Success);
          } else {
            await snapshot.forEach(function (childSnapshot) {
              // key will be "ada" the first time and "alan" the second time
              key = childSnapshot.key;
              // childData will be the actual contents of the child
              var childData = childSnapshot.val();
              _data.unshift(childData);
              // console.log(_data);
              resolve(Success);
            });
          }
        }).catch((err) => {
          reject(Error);
        });

      const obj = {
        data: _data,
        uid: uid
      }
      commit('GET_DATA', obj)

    });
  },
  DeleteData({ commit }, item) {
    return new Promise((resolve, reject) => {
      let userRef = firebase.database().ref('poll/' + item.data.key);
      userRef.remove().then(() => {
        commit('DELETE_DATA', item.index)
        resolve(Success);
      }).catch(() => {
        reject(Error);
      })
    })
  },
  UpdateData({ commit }, item) {
    return new Promise((resolve, reject) => {
      pollRef.child(item.key).update({
        topic: item.name,
        detail: item.detail,
        type: item.type
      }).then(() => {
        commit('UPDATE_POLL', item);
        resolve(Success);
      }).catch(() => {
        reject(Error);
      })
    })
  },
  UpdateChoiz({ commit }, item) {
    return new Promise((resolve, reject) => {
      pollRef.child(item.key).update({
        choizs: item.choizs,
      }).then(() => {
        commit('UPDATE_POLL', item);
        resolve(Success);
      }).catch(() => {
        reject(Error);
      })
    })
  },
  uploadImage({ commit }, file) {

  },
  ViewData({ commit }, item) {
    return new Promise((resolve, reject) => {
      firebase.database().ref('/poll/' + item).on('value', (resp) => {
        commit('VIEW_POLL', resp.val());
        resolve(resp.val());
      }, (err) => {
        console.log(err);
        reject(err);
      });
    });
  },
  ViewDataTest({ commit }) {
    return new Promise((resolve, reject) => {
      firebase.database().ref('/poll/' + "-MI_b4A9bggnAsr0sylQ").on('value', (resp) => {
        console.log(resp.val());
        commit('VIEW_POLL', resp.val());
        resolve(resp.val());
      }, (err) => {
        console.log(err);
        reject(err);
      });
    });
  },
  VoteTest({ commit }, item) {
    return new Promise((resolve, reject) => {
      firebase.database().ref('/poll/' + "-MI_b4A9bggnAsr0sylQ").once('value').then(function (snapshot) {
        var childData = snapshot.val();
        firebase.database().ref('/poll/' + "-MI_b4A9bggnAsr0sylQ" + '/choizs/' + item.index + '/count').set(childData.choizs[item.index].count + 1)
      }).then(() => {
        resolve(Success);
      })
    });
  },
  beforeplaySetPublic({ commit }, item) {
    return new Promise((resolve, reject) => {
      pollRef.child(item).update({
        statusPublic: true,
      }).then(() => {
        resolve(Success);
      }).catch(() => {
        reject(Error);
      })
    })
  }
}
